import * as fromDatatype from "../datatype-library/index";

export interface bl_del_logistic_provider_hdr_RowInterface{

    guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    account_no: fromDatatype.VarcharDatatypeInterface;
    provider_type: fromDatatype.VarcharDatatypeInterface;
    app_generic_resources_hdr_guid: fromDatatype.GuidDataFieldInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    provider_status: fromDatatype.VarcharDatatypeInterface;
    address_json: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    options_json: fromDatatype.JsonDatatypeInterface;
    log_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;

}



export class bl_del_logistic_provider_hdr_RowClass
    implements bl_del_logistic_provider_hdr_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    account_no: fromDatatype.VarcharDatatypeInterface;
    provider_type: fromDatatype.VarcharDatatypeInterface;
    app_generic_resources_hdr_guid: fromDatatype.GuidDataFieldInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    provider_status: fromDatatype.VarcharDatatypeInterface;
    address_json: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    options_json: fromDatatype.JsonDatatypeInterface;
    log_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;

}
